import React , { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Notification from '@tds/core-notification';
import { Text } from '../orderDetails/css';


const MessageNotification = ({ message, variant }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, 6000);

    // Clear the timer if the component is unmounted
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <Notification variant={variant} dismissible copy="en">
      <Text bold>{message}</Text>
    </Notification>
  );
};

MessageNotification.propTypes = {
  message: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired
};

export default MessageNotification;